import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ADD_SCHEDULE_EVENT,
  GET_SCHEDULE_DAY_EVENTS,
  GET_SCHEDULE_EVENTS,
  UPDATE_SCHEDULE_EVENT,
} from '~/utils/constants/actionType';
import {
  IEditEventPayload,
  IParamsGetScheduleEvent,
  IResponseGetScheduleDayEvent,
  IResponseGetScheduleEvent,
} from '~/utils/interface/schedule';
import scheduleEventApi from '~/apis/schedule';

export const handleGetEvents = createAsyncThunk<IResponseGetScheduleEvent, IParamsGetScheduleEvent>(
  GET_SCHEDULE_EVENTS,
  async (params: IParamsGetScheduleEvent, { rejectWithValue }) => {
    try {
      const res = await scheduleEventApi.getEvents(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetDayEvents = createAsyncThunk<IResponseGetScheduleDayEvent, IParamsGetScheduleEvent>(
  GET_SCHEDULE_DAY_EVENTS,
  async (params: IParamsGetScheduleEvent, { rejectWithValue }) => {
    try {
      const res = await scheduleEventApi.getDayEvents(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleAddEvent = createAsyncThunk<any, IEditEventPayload>(
  ADD_SCHEDULE_EVENT,
  async (eventPayload: IEditEventPayload, { rejectWithValue }) => {
    try {
      const res = await scheduleEventApi.addEvent(eventPayload);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUpdateEvent = createAsyncThunk<any, { id: string; data: IEditEventPayload }>(
  UPDATE_SCHEDULE_EVENT,
  async ({ id, data: eventPayload }: { id: string; data: IEditEventPayload }, { rejectWithValue }) => {
    try {
      const res = await scheduleEventApi.updateEvent(id, eventPayload);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
